(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.style
  (:require
   [frontend.ui.style.theme.core :as theme]))

(defn upload-input
  []
  {:display "none"})

(defn table-background
  []
  {:background (theme/color [:lp-editor :page :background])})

(defn specific-investors-table
  []
  {:width           "100%"
   :border-collapse "separate"
   :border-spacing  0
   :border          "1px solid #ddd"
   :border-radius   "8px"
   :overflow        "hidden"
   :margin-top      "1rem"
   :table-layout "fixed"
   :overflow-x   "auto"})

(defn table-header-cell
  []
  {:text-align "left"
   :padding    "0.75rem"
   :color      "#999"})

(defn table-header-cell-right
  []
  {:text-align "right"
   :padding    "0.75rem"
   :color      "#999"})

(defn table-row
  []
  {:border-top "1px solid #ddd"})

(defn investor-cell
  []
  {:padding        "0.75rem"
   :border-top     "1px solid #ddd"
   :vertical-align "top"})

(defn file-cell
  []
  {:padding        "0.75rem"
   :border-top     "1px solid #ddd"
   :vertical-align "top"
   :width          "50%"
   :max-width      "50%"
   :overflow       "hidden"})

(defn investor-name
  []
  {:font-weight "bold"
   :white-space   "nowrap"})

(defn contact-label
  []
  {:margin-top "0.25rem"
   :color      "#555"
   :font-size  "0.85rem"})

(defn contact-badge
  []
  {:margin-left    "0.5rem"
   :background     (theme/color [:layout :primary :bg])
   :color          "#777"
   :padding        "0.1rem 0.4rem"
   :border-radius  "8px"
   :font-size      "0.75rem"})

(defn upload-button
  []
  {:cursor          "pointer"
   :display         "inline-flex"
   :justify-content "flex-end"
   :width           "100%"
   :align-items     "center"
   :gap             "0.4rem"
   :font-size       "0.85rem"
   :margin-bottom   "0.5rem"
   :color           "#333"})

(defn file-badges-container
  []
  {:display               "grid"
   :grid-template-columns "repeat(auto-fit, minmax(0, max-content))"
   :max-width             "100%"
   :gap                   "0.5rem"
   :width                 "100%"
   :box-sizing            "border-box"
   :overflow              "hidden"
   :margin-top            "0.25rem"
   :justify-content       "flex-end"
   :justify-items         "end"})

(defn file-badge
  []
  {:background    (theme/color [:layout :primary :bg])
   :padding       "0.4rem 0.5rem"
   :border-radius "4px"
   :font-size     "0.8rem"
   :color         "#444"
   :display       "flex"
   :align-items   "center"
   :gap           "0.4rem"
   :min-width     0
   :max-width     "max-content"
   :width         "100%"})

(defn file-badge-filename
  []
  {:white-space   "nowrap"
   :overflow      "hidden"
   :text-overflow "ellipsis"
   :flex-grow     1
   :flex-shrink   1
   :min-width     0
   :max-width     "100%"})

(defn materials-tab-container
  []
  {:padding "1rem"})

(defn private-material-bulk-upload-actions
  []
  {:display         "flex"
   :justify-content "flex-end"})

(defn private-material-bulk-upload-description
  []
  {:color     "#667085"
   :font-size "0.95rem"})

(defn private-material-bulk-upload-description-row
  []
  {:display       "flex"
   :align-items   "center"
   :gap           "0.5rem"
   :margin-bottom "1rem"})

(defn private-material-bulk-upload-info-icon
  []
  {:display     "inline-flex"
   :align-items "center"
   :color       "#98a2b3"
   :cursor      "help"
   :font-size   "0.9rem"})

(defn private-material-bulk-upload-dropzone
  []
  {:margin-bottom "1rem"})

(defn private-material-bulk-upload-files-wrapper
  []
  {:display        "flex"
   :flex-direction "column"
   :gap            "0.75rem"
   :margin-bottom  "1.5rem"})

(defn private-material-bulk-upload-files-title
  []
  {:font-size   "1rem"
   :font-weight "600"})

(defn private-material-bulk-upload-files-list
  []
  {:display        "flex"
   :flex-direction "column"
   :gap            "0.5rem"
   :max-height     "320px"
   :overflow-y     "auto"})

(defn private-material-bulk-upload-review-summary
  []
  {:margin-top    "0.5rem"
   :margin-bottom "0.75rem"
   :font-size     "0.9rem"
   :font-weight   "600"
   :color         "#667085"})

(defn private-material-bulk-upload-review-table
  []
  {:display        "flex"
   :flex-direction "column"
   :border         "1px solid #d0d5dd"
   :border-radius  "8px"
   :max-height     "420px"
   :overflow-y     "auto"
   :overflow-x     "hidden"})

(defn private-material-bulk-upload-review-header
  []
  {:display               "grid"
   :grid-template-columns "minmax(0, 1.4fr) 160px minmax(300px, 400px)"
   :gap                   "1rem"
   :padding               "1rem"
   :position              "sticky"
   :top                   0
   :z-index               1
   :border-bottom         "1px solid #d0d5dd"
   :background            "#fff"})

(defn private-material-bulk-upload-review-header-cell
  []
  {:font-size   "0.95rem"
   :font-weight "600"
   :color       "#667085"})

(defn private-material-bulk-upload-review-match-header-cell
  []
  {:font-size   "0.95rem"
   :font-weight "600"
   :color       "#667085"
   :text-align  "left"})

(defn private-material-bulk-upload-review-rows
  []
  {:display        "flex"
   :flex-direction "column"})

(defn private-material-bulk-upload-review-row
  []
  {:display               "grid"
   :grid-template-columns "minmax(0, 1.4fr) 160px minmax(300px, 400px)"
   :gap                   "1rem"
   :padding               "1rem"
   :border-bottom         "1px solid #eaecf0"
   :align-items           "center"})

(defn private-material-bulk-upload-review-cell
  []
  {:font-size   "0.95rem"
   :font-weight "500"
   :min-width   0
   :word-break  "break-word"})

(defn private-material-bulk-upload-review-match-cell
  []
  {:display         "flex"
   :align-items     "center"
   :justify-content "flex-start"
   :gap             "0.375rem"
   :font-size       "0.9rem"})

(defn private-material-bulk-upload-match-text-success
  []
  {:color "#667085"})

(defn private-material-bulk-upload-match-text-neutral
  []
  {:color "#667085"})

(defn private-material-bulk-upload-review-select-cell
  []
  {:min-width "300px"
   :width     "100%"})

(defn private-material-bulk-upload-review-footer
  []
  {:display         "flex"
   :justify-content "space-between"
   :margin-top      "1rem"})

(defn private-material-bulk-upload-match-icon-success
  []
  {:color "#16a34a"})

(defn private-material-bulk-upload-match-icon-failure
  []
  {:color "#dc2626"})

(defn private-material-bulk-upload-file-row
  []
  {:display         "flex"
   :align-items     "center"
   :justify-content "space-between"
   :gap             "1rem"})

(defn private-material-bulk-upload-file-name
  []
  {:font-size   "0.95rem"
   :font-weight "500"
   :min-width   0})

(defn private-material-bulk-upload-remove-button
  []
  {:border     "none"
   :background "transparent"
   :cursor     "pointer"
   :color      "#667085"
   :padding    "0 0.5rem 0 0"})

(defn private-material-bulk-upload-progress
  []
  {:display         "flex"
   :flex-direction  "column"
   :align-items     "center"
   :justify-content "center"
   :text-align      "center"
   :gap             "0.75rem"
   :padding         "2rem 1rem"})

(defn private-material-bulk-upload-progress-title
  []
  {:font-size   "1rem"
   :font-weight "600"})

(defn private-material-bulk-upload-progress-description
  []
  {:color     "#667085"
   :font-size "0.95rem"})

(defn private-material-bulk-upload-progress-count
  []
  {:font-size   "0.95rem"
   :font-weight "600"})

(defn private-material-bulk-upload-progress-bar-wrapper
  []
  {:width     "100%"
   :max-width "520px"})

(defn private-material-bulk-upload-progress-current-file
  []
  {:font-size  "0.9rem"
   :color      "#667085"
   :max-width  "100%"
   :word-break "break-word"})

(defn private-material-bulk-upload-cleanup-actions
  []
  {:display         "flex"
   :justify-content "flex-end"
   :margin-bottom   "1rem"})

(defn private-material-bulk-upload-cleanup-table
  []
  {:border        "1px solid #d0d5dd"
   :border-radius "8px"
   :overflow      "hidden"
   :margin-bottom "1rem"})

(defn private-material-bulk-upload-cleanup-header
  []
  {:display               "grid"
   :grid-template-columns "minmax(220px, 1fr) minmax(0, 1fr)"
   :gap                   "1rem"
   :padding               "1rem"
   :border-bottom         "1px solid #d0d5dd"
   :background            "#fff"})

(defn private-material-bulk-upload-cleanup-header-cell
  []
  {:font-size   "0.95rem"
   :font-weight "600"
   :color       "#667085"})

(defn private-material-bulk-upload-cleanup-rows
  []
  {:display        "flex"
   :flex-direction "column"
   :max-height     "320px"
   :overflow-y     "auto"})

(defn private-material-bulk-upload-cleanup-row
  []
  {:display               "grid"
   :grid-template-columns "minmax(220px, 1fr) minmax(0, 1fr)"
   :gap                   "1rem"
   :padding               "1rem"
   :border-bottom         "1px solid #eaecf0"
   :align-items           "center"})

(defn private-material-bulk-upload-cleanup-investor-cell
  []
  {:font-size   "0.95rem"
   :font-weight "500"
   :min-width   0
   :word-break  "break-word"})

(defn private-material-bulk-upload-cleanup-files-cell
  []
  {:display        "flex"
   :flex-direction "column"
   :gap            "0.75rem"
   :min-width      0})

(defn private-material-bulk-upload-cleanup-material-item
  []
  {:display         "flex"
   :justify-content "space-between"
   :align-items     "center"
   :gap             "1rem"})

(defn private-material-bulk-upload-cleanup-material-name
  []
  {:font-size   "0.95rem"
   :font-weight "500"
   :min-width   0
   :word-break  "break-word"})

(defn file-input-wrapper
  []
  {:margin-bottom "0.75rem"
   :margin-top    "0.9rem"})

(defn material-row
  []
  {:display         "flex"
   :justify-content "space-between"
   :align-items     "center"
   :padding         "0.9rem 1rem"
   :margin-bottom   "0.75rem"
   :background      (theme/color [:layout :primary :bg])})

(defn material-filename
  []
  {:font-weight "bold"
   :color       "#333"})

(defn material-meta-wrapper
  []
  {:display     "flex"
   :align-items "center"
   :gap         "1rem"})

(defn material-size
  []
  {:font-size "0.9rem"
   :color     "#777"})

(defn no-materials-wrapper
  []
  {:text-align "center"
   :margin     "2rem auto"
   :color      "#777"})

(defn no-materials-title
  []
  {:font-weight    "600"
   :margin-bottom  "0.25rem"
   :font-size      "1rem"
   :color          "#444"})

(defn no-materials-subtext
  []
  {:font-size "0.85rem"
   :color     "#777"})

(defn tab-header-container
  []
  {:display         "flex"
   :justify-content "center"
   :background      (theme/color [:table :th :bg])})

(defn tab-header-button
  [active?]
  (merge
   {:padding        "0.75rem 1.5rem"
    :text-align     "left"
    :text-transform "uppercase"
    :font-size      (theme/text-size :xxsmall :size)
    :background     (theme/color [:table :th :bg])
    :color          (theme/color [:table :th :fg])
    :vertical-align :bottom
    :cursor         "pointer"
    :line-height    1.5}
   (when active?
     {:font-weight "bold"})))

(defn popover-text
  []
  {:font-weight "500"
   :font-size   "0.75rem"
   :margin-bottom "0.5rem"
   :color       "#333"})

(defn popover-investor-name
  []
  {:font-size   "0.65rem"
   :margin-top  "0.25rem"
   :margin-bottom "0.75rem"
   :color       "#666"})

(defn export-perm-container
  []
  {:display        "flex"
   :flex-direction "column"
   :gap            "1.5rem"})

(defn export-perm-subsection
  []
  {:display        "flex"
   :flex-direction "column"
   :gap            "0.5rem"})

(defn export-perm-subsection-title
  []
  {:font-size   "0.875rem"
   :font-weight "600"
   :color       "#333"})

(defn export-perm-card
  []
  {:border        (str "1px solid " (theme/color [:table :border]))
   :border-radius "8px"
   :overflow      "hidden"})

(defn export-perm-header-row
  []
  {:display     "flex"
   :align-items "center"
   :padding     "0.5rem 1rem"})

(defn export-perm-row
  []
  {:display     "flex"
   :align-items "center"
   :padding     "0.75rem 1rem"
   :border-top  (str "1px solid " (theme/color [:table :border]))})

(defn export-perm-row-label
  []
  {:flex           "1"
   :font-size      "0.75rem"
   :text-transform "uppercase"
   :color          "#999"})

(defn export-perm-col-header
  []
  {:width          "4rem"
   :text-align     "center"
   :font-size      "0.75rem"
   :text-transform "uppercase"
   :color          "#999"})

(defn export-perm-cell
  []
  {:width           "4rem"
   :display         "flex"
   :justify-content "center"})

(defn export-perm-check
  []
  {:color (theme/color [:badge :success :bg])})

(defn export-perm-dash
  []
  {:color "#999"})

(defn export-perm-review
  []
  {:display        "flex"
   :flex-direction "column"
   :border-top     (str "1px solid " (theme/color [:table :border]))})

(defn export-perm-review-title
  []
  {:padding        "0.5rem 1rem"
   :font-size      "0.75rem"
   :text-transform "uppercase"
   :color          "#999"})

(defn export-perm-review-row
  []
  {:display     "flex"
   :align-items "center"
   :padding     "0.5rem 1rem"})

(defn export-perm-review-label
  []
  {:flex      "1"
   :font-size "0.875rem"
   :color     "#333"})

(defn export-perm-investor
  [first?]
  (merge
   {}
   (when-not first?
     {:border-top (str "1px solid " (theme/color [:table :border]))})))

(defn export-perm-investor-header
  []
  {:display         "flex"
   :align-items     "center"
   :justify-content "space-between"
   :padding         "0.75rem 1rem"
   :cursor          "pointer"})

(defn export-perm-investor-header-left
  []
  {:display     "flex"
   :align-items "center"
   :gap         "0.75rem"})

(defn export-perm-investor-name
  []
  {:font-size   "0.875rem"
   :font-weight "600"
   :color       "#333"})

(defn export-perm-investor-contacts-count
  []
  {:font-size "0.75rem"
   :color     "#999"})

(defn export-perm-chevron
  []
  {:color "#999"})

(defn export-perm-investor-body
  []
  {:display        "flex"
   :flex-direction "column"
   :border-top     (str "1px solid " (theme/color [:table :border]))})

(defn export-perm-default-toggle-row
  []
  {:display         "flex"
   :align-items     "center"
   :justify-content "space-between"
   :padding         "0.75rem 1rem"})

(defn export-perm-review-toggle
  []
  {:display         "flex"
   :align-items     "center"
   :justify-content "space-between"
   :padding         "0.75rem 1rem"
   :cursor          "pointer"
   :border-top      (str "1px solid " (theme/color [:table :border]))
   :font-size       "0.75rem"
   :text-transform  "uppercase"
   :color           "#999"})

(defn export-perm-footer
  []
  {:display         "flex"
   :align-items     "center"
   :justify-content "space-between"})

(defn export-perm-unsaved
  []
  {:display     "flex"
   :align-items "center"
   :gap         "0.4rem"
   :font-size   "0.875rem"
   :color       (theme/color [:badge :danger :bg])})

(defn export-perm-tab-dirty
  []
  {:border        (str "1px solid " (theme/color [:badge :danger :bg]))
   :border-radius "4px"})

(defn export-perm-dirty-icon
  []
  {:margin-left "0.4rem"
   :color       (theme/color [:badge :danger :bg])})
